"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Source = exports.CustomOption = void 0;
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_components_1 = __importDefault(require("styled-components"));
exports.CustomOption = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
exports.Source = (0, styled_components_1.default)(wl_ui_kit_1.Body2) `
  margin-left: ${(0, wl_ui_kit_1.getSizeBy)(1.5)};
  color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'lowEmphasis')};
`;
